<template>
  <button :class="classes" :style="setDisplay" type="button" @click="handleClick">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'RfidButton',
  props: {
    loginPage: {
      type: Boolean,
      default: false
    },
    logoutPage: {
      type: Boolean,
      default: false
    },
    display: {
      type: String,
      default: ''
    }
  },

  computed: {
    classes () {
      if (this.logoutPage) {
        return [`btn btn-primary w110`]
      } else {
        const cls = this.loginPage ? 'w100p btn-block' : 'w200'
        return [`btn btn-primary btn-lg ${cls}`]
      }
    },
    setDisplay () {
      const style = this.display === '' ? '' : 'display: ' + this.display + ';'
      return style
    }
  },

  methods: {
    handleClick () {
      this.$emit('handleClick')
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/atoms/RfidButton.vue